<template>
    <LandingPage>
<template slot="taption_header">
  <div id="text1-strings">
           <p>동영상에 자막을 쉽게 추가</p>
           <p>간편한 AI 영상 분석</p>
           <p>간편한 동영상 번역</p>
           <p>동영상을 텍스트로 쉽게 변환</p>
         </div>
         <span id="text1"></span>
</template>
<template slot="landing_description">40+개국 언어로 동영상 분석하다, 받아쓰기, 번역, 자막 추가까지</template>

<template slot="intro_video">

    <video playsinline class="intro-video" :src='"@/assets/video/landing_en.mp4"' autoplay frameborder="0" height="350" width="575" muted></video>
</template>

<template slot="start_your_trial">탭션을 사용해보세요</template>

<template slot="use_case_title">놀라운 플랫폼</template>
<template slot="youtubers">텍스트로 변환하여 자막 추가</template>
<template slot="youtubers_question">오디오 파일을 자동으로 텍스트로 변환한 후 <span style="color:#00d1b2;">단일 또는 이중 언어 자막을 추가</span>합니다.</template>

<template slot="journalists">AI 분석</template>
<template slot="journalists_question">AI가 요약하고 제목을 붙이며, 비디오 전용 <span style="color:#00d1b2;">ChatGPT</span>를 제공합니다.</template>
<!-- <template slot="youtubers">동영상을 텍스트로 변환</template>
<template slot="youtubers_question">사용중인 장치 및 유튜브, 구글 드라이브, 줌 등에서 파일을 불러와 자동 받아쓰기 할 수 있습니다</template>


<template slot="journalists">동영상에 자막을 추가</template>
<template slot="journalists_question">동영상에 자동으로 2개국어 자막을 추가할 수 있습니다</template> -->

<template slot="translators">비디오 번역</template>
<template slot="translators_question"><span style="color:#00d1b2;">50개 이상 언어</span>로 자동 비디오 번역 지원</template>
<template slot="speaker">화자 식별</template>
<template slot="speaker_question">회의록, 오디오, 팟캐스트 등 자동 화자 식별 제공</template>

<template slot="timealign">TXT 파일 타임코드 추가</template>
<template slot="timealign_question">제공된 텍스트에 타임코드와 화자 표시 추가</template>

<template slot="audiotomp4">오디오를 비디오로 변환</template>
<template slot="audiotomp4_question">오디오 전사 후 이미지 추가로 맞춤 자막 비디오 생성</template>

<template slot="importsrt">TXT 또는 SRT 자막 편집</template>
<template slot="importsrt_question">자동 자막 타임라인 생성 또는 SRT 파일 업로드 후 강력한 편집 도구로 교정</template>

<template slot="share">기업용 기능 및 보안</template>
<template slot="share_question">맞춤 권한, 공유 기능으로 효율적인 협업 관리</template>

<template slot="learnmore">자세히 알아보기</template>


<template slot="simple_workflow">간단한 프로세스</template>
<template slot="upload">업로드하기</template>
<template slot="upload_description">Taption 플랫폼에 오디오 및 비디오 파일을 업로드하거나 YouTube, Webex, Zoom에서 직접 다운로드하거나 Google Drive에서 다운로드하세요. 다양한 형식을 자동 변환하여 빠르고 정확하게 음성을 텍스트로 변환합니다.</template>
<template slot="edit_translate">편집하기</template>
<template slot="edit_translate_description">온라인 비디오 전사 편집 플랫폼에서 텍스트가 자동으로 타임라인과 동기화됩니다. 텍스트 편집, 자막 분할, 비디오 편집 시 수동 시간 조정이 필요 없습니다!</template>

<template slot="transcribe">AI 분석</template>
<template slot="transcribe_description">비디오에 대해 질문하거나 지시하세요. AI 분석을 통해 개인 맞춤 ChatGPT를 경험하세요! 비디오 요약, 핵심 내용 추출로 주요 정보를 쉽게 파악할 수 있습니다.</template>
<template slot="translate">번역</template>
<template slot="translate_description">온라인 번역 소프트웨어로 자동 번역의 동기화 문제와 직역 문제를 해결합니다. 40개 이상의 언어를 지원하며, 중국어-영어, 영어-중국어, 일본어, 한국어, 베트남어 등 포함.</template>
<template slot="export">내보내기</template>
<template slot="export_description">자막 편집과 비디오 편집 완료 후, 다양한 형식으로 내보낼 수 있습니다 (단일 또는 이중 언어 자막이 포함된 MP4, SRT, VTT, PDF, TXT).</template>
<template slot="try_it_now">지금 시도해보세요!</template>



<template slot="editing_platform_desc1">하단 타임라인을 사용하여 영상을 손쉽게 편집 및 자르세요. 편집이 자막과 겹칠 경우, 자동으로 텍스트를 제거하고 시간을 조정해 자막의 정확성을 유지합니다. 빠르고 전문적인 자막 비디오 제작에 이상적입니다.</template>
      <template slot="video_time_stampped">
            <div class="video-wrapper" @click="onClicked('video1', true)">
                  <div class="play-button" v-show="!videoState.video1">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
                  <video id="video1" ref="video1" playsinline preload="none" poster="../assets/images/thumbnail/cut_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/Trim_Cut_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
            </div>
      </template>
      <template slot="editing_platform">강력한 편집 플랫폼</template>
        <template slot="editing_platform_desc0">자막을 삭제함으로써 쉽게 비디오를 자를 수 있습니다. 이 기능은 텍스트를 편집할 때 비디오 길이를 조정하여 매끄러운 결과를 보장합니다. 빠르고 정확한 편집에 적합하며, 비디오 편집 과정을 간소화하여 손쉽게 완성된 결과물을 제공합니다.</template>
      <template slot="video_trimmed">
            <div class="video-wrapper" @click="onClicked('video0', true)">
                  <div class="play-button" v-show="!videoState.video0">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
          <video id="video0" ref="video0" playsinline preload="none" poster="../assets/images/thumbnail/trim_thumbnail_zh.webp" class="intro-video" :src='"@/assets/video/Trim_Chinese.mp4"' frameborder="0" height="350" width="575" muted></video>
            </div>
      </template>

      <template slot="editing_platform_desc2">AI 분석 기능은 업로드된 동영상을 심층 분석하여 요약, 핵심 포인트 나열, 내용 검색 및 질문 답변을 지원합니다. 이를 통해 동영상 이해와 상호작용 효율성이 향상됩니다. 또한 YouTube 챕터 생성, 자동 제목 생성, 오타 자동 수정 등 다양한 템플릿을 제공하여 동영상 분석 및 편집 과정을 더욱 간소화합니다.</template>
      <template slot="video_replace_all">
          <div class="video-wrapper" @click="onClicked('video2', true)">
              <div class="play-button" v-show="!videoState.video2">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video2" ref="video2" playsinline preload="none" poster="../assets/images/thumbnail/analysis_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/AI_Analysis_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template>
      <template slot="editing_platform_desc3">이 MP4 파일은 '메모' 기능을 소개합니다. 사용자는 비디오의 특정 부분에 주석이나 텍스트를 남겨 다른 사용자가 볼 수 있게 하고, 노트로도 활용할 수 있습니다. 이 기능은 각각의 시간에 맞춰 빠르게 메모를 확인할 수 있어 다양한 기록에 편리합니다.</template>
      <template slot="video_add_dictionary">
        <div class="video-wrapper" @click="onClicked('video3', true)">
              <div class="play-button" v-show="!videoState.video3">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video3" ref="video3" playsinline preload="none" poster="../assets/images/thumbnail/memo_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/Memo_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template>

            

<template slot="low_cost">저렴한 가격</template>
<template slot="title_basic">사용한 만큼 결제 플랜</template>
<template slot="basic_cost_usd">$8</template>
<template slot="basic_cost_ntd">(240 NTD)</template>
<template slot="hour">hour</template>
<template slot="basic_feature5">이용가능시간 <span style="color: #00d1b2;">60분</span></template>
<template slot="basic_feature1">자동 받아쓰기</template>
<template slot="basic_feature2">40+ 언어 지원 </template>
<template slot="basic_feature3">텍스트 편집기</template>
<template slot="basic_feature4">50+개 이상의 언어로 번역</template>
<template slot="basic_feature7">AI 맞춤사전</template>
<template slot="basic_feature6">상업적 이용 가능</template>
<template slot="basic_feature8">다국어 자체삽입 자막 지원</template>

<template slot="title_premium">프리미엄 플랜</template>
<template slot="premium_cost_usd">$12</template>
<template slot="premium_cost_ntd">(360 NTD)</template>
<template slot="premium_basic_cost_usd">$6</template>
<template slot="month">/월</template>

<template slot="premium_before"><span class="landing-arrow-left">&#10229;</span>「사용한 만큼 결제」플랜의 모든 기능 포함</template>
<template slot="premium_feature1"><span style="color: #00d1b2;">120 분</span>의 무료이용시간이 매월 계정에 적립<br><span style="color:#797676;font-size:14px;font-weight: 100;">(남은 이용시간은 이월되며 구독 취소시까지 유효)</span></template>
<template slot="premium_feature1_tooltip">만약 매월 적립된 이용시간이 사용되지 않고 남은 경우, 다음 달로 이월되며 구독을 취소하실 때까지 계속해서 유효합니다. <br>매월 적립되는 무료이용시간은 추가로 구매하신 이용시간보다 우선 차감됩니다. <br>추가로 구매하신 이용시간은 구독을 취소하신 후에도 만료되지 않고 유효합니다.</template>
<template slot="premium_feature2">이용시간 시간당 구매시 25% 할인</template>
<template slot="premium_feature3">자체자막 동영상 내보내기가 무제한 무료</template>
<template slot="premium_feature4">받아쓰기 공유 및 동시편집</template>
<template slot="premium_feature5">음성 녹음 파일을 자막 달린 동영상으로 내보내기 가능</template>
<template slot="premium_feature6">비디오 클립(자막 자동 조정)</template>

<template slot="title_corp">엔터프라이즈 플랜</template>
<template slot="bulk_cost_usd">$69</template>
<template slot="bulk_cost_ntd">(2070 NTD)</template>
<template slot="bulk_basic_cost_usd">$4</template>
<template slot="bulk_before"><span class="landing-arrow-left">&#10229;</span>「사용한 만큼 결제」 및 「프리미엄 플랜」의 모든 기능 포함</template>
 <template slot="bulk_feature2">이용시간 시간당 구매시 63% 할인</template>
<template slot="premium_feature1_bulk"><span style="color: #00d1b2;">1000 분</span>의 무료이용시간이 매월 계정에 적립<br><span style="color:#797676;font-size:14px;font-weight: 100;">(남은 이용시간은 이월되며 구독 취소시까지 유효)</span></template>
<template slot="bulk_feature1">회사명 및 납세자 등록번호가 기재된 영수증 다운로드 가능</template>

 <template slot="bulk_feature3">무료이용시간을 다른 유저와 공유</template>
 <template slot="bulk_feature4">6단계 유저 권한 조정 및 관리</template>

<template slot="go_to_price">더 알아보기</template> 
</LandingPage>
</template>

<script>
import LandingPage from "./LandingPage";

export default {
  data: () => ({
      videoState:{
          video0:false,
          video1:false,
          video2:false,
          video3:false  
      }
  }),
  components: {
    LandingPage
  },
  methods: {
    onClicked(videoType, isPlay){
        const me = this;
        me.$refs[videoType].play();
        me.videoState[videoType] = isPlay;
    }
  },
  mounted(){
    const me = this;
    const video0 = document.getElementById("video0");  
    const video1 = document.getElementById("video1");   
    const video2 = document.getElementById("video2");   
    const video3 = document.getElementById("video3");   


    if(video0){
        video0.onended = function() {
            me.videoState.video0 = false;
        }
        // video0.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video0 = false;
        // } 
    }


    if(video1){
        video1.onended = function() {
            me.videoState.video1 = false;
        }
        // video1.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video1 = false;
        // } 
    }


    if(video2){
        video2.onended = function() {
            me.videoState.video2 = false;
        } 
        // video2.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video2 = false;
        // } 
    }

    if(video3){
        video3.onended = function() {
            me.videoState.video3 = false;
        } 
        // video3.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video3 = false;
        // } 
    }
  }
}

</script>


           